<!--RIS-->
<!--v1.0-->
<!--患者详情-->
<!--宋增玲-->
<!--2018.08.09-->
<template>
  <div class="patient-continer" v-loading='Loading' v-if='regpatient.length !== 0'>
    <el-row id="patient-wrapper" class="patient-wrapper">
      <el-row class="patient-subheader">
        登记信息
      </el-row>
      <el-row class="main">
        <!--侧边栏开始-->
        <el-col style="width:155px;" class="patient-sidebar">
          <el-menu
            default-active="1"
            class="el-menu-vertical-demo">
            <el-menu-item index="1" >
              <a slot="title"  ><svg-icon  icon-class='people_list' style="margin-right:10px;"></svg-icon>基本资料</a>
            </el-menu-item>
            <el-menu-item index="2">
              <a slot="title"  ><svg-icon  icon-class='news' style="margin-right:10px;"></svg-icon>申请信息</a>
            </el-menu-item>
            <el-menu-item index="3">
              <a slot="title" ><svg-icon  icon-class='check-info' style="margin-right:10px;"></svg-icon>检查信息</a>
            </el-menu-item>
            <el-menu-item index="4">
              <a slot="title"><svg-icon  icon-class='news_hot' style="margin-right:10px;"></svg-icon>详细信息</a>
            </el-menu-item>
          </el-menu>
        </el-col>
        <!--侧边栏结束-->
        
        <el-col :span="21" class="patient-main" >
          <!--基本资料开始-->
          <div class="content-wrapper" style="margin-top:0px;">
            <div id="basicinfo"  class="patient-title" ><svg-icon  icon-class='people_list' style="margin-right:10px;"></svg-icon>基本资料</div>
            <div class="patient-content">
              <el-row class="content-item">
                <el-col :span="2"><label >患者姓名：</label></el-col>
                <el-col :span="4">{{regpatient.patient.name}}&nbsp;</el-col>
                <el-col :span="2"><label >拼音姓名：</label></el-col>
                <el-col :span="4">{{regpatient.patient.pyCode}}&nbsp;</el-col>
                <el-col :span="2"><label >性别：</label></el-col>
                <el-col :span="4">{{regpatient.patient.sex}}&nbsp;</el-col>
                <el-col :span="2"><label >出生日期：</label></el-col>
                <el-col :span="4">{{regpatient.patient.birthDate }}&nbsp;</el-col>
              </el-row>
              <el-row class="content-item">
                <el-col :span="2"><label >年龄：</label></el-col>
                <el-col :span="4">{{regpatient.patient.age}}{{regpatient.patient.ageUnit}}&nbsp;</el-col>
                <el-col :span="2"><label >电话：</label></el-col>
                <el-col :span="4">{{regpatient.patient.phoneNo}}&nbsp;</el-col>
                <el-col :span="2"><label >现住地址：</label></el-col>
                <el-col :span="10">{{regpatient.patient.address}}&nbsp;</el-col>
              </el-row>
            </div>
          </div>
           <!--基本资料结束-->
           <!--申请信息开始-->
           <div class="content-wrapper">
            <div id="applyinfo" class="patient-title"><svg-icon  icon-class='news' style="margin-right:10px;"></svg-icon>申请信息</div>
            <div class="patient-content">
              <el-row class="content-item">
                <el-col :span="2"><label >患者来源：</label></el-col>
                <el-col :span="4">{{regpatient.patientSource}}&nbsp;</el-col>
                <el-col :span="2"><label >门诊号：</label></el-col>
                <el-col :span="4">{{regpatient.outpatientNo}}&nbsp;</el-col>
                <el-col :span="2"><label >申请科室：</label></el-col>
                <el-col :span="4">{{regpatient.applyDepart}}&nbsp;</el-col>
                <el-col :span="2"><label >申请医生：</label></el-col>
                <el-col :span="4">{{regpatient.applyDoctor}}&nbsp;</el-col>
              </el-row>
              <el-row class="content-item">
                <el-col :span="2"><label >登记单号：</label> </el-col>
                <el-col :span="4">{{regpatient.regNo}}&nbsp;</el-col>
                <el-col :span="2"><label >床位号：</label></el-col>
                <el-col :span="4">{{regpatient.bedNo}}&nbsp;</el-col>
                <el-col :span="2"><label >诊疗类型：</label> </el-col>
                <el-col :span="4">{{regpatient.diagnosis}}&nbsp;</el-col>
                <el-col :span="2"><label >影像号：</label></el-col>
                <el-col :span="4">{{regpatient.patient.patientNo}}&nbsp;</el-col>
                <!-- <el-col :span="6"><label >HISID：</label>{{regpatient.applyDoctor}}</el-col>
                <el-col :span="6"><label >病区号：</label>{{regpatient.applyDoctor}}</el-col> -->
              </el-row>
              <!-- <el-row class="content-item">
                <el-col :span="2"><label >病史：</label></el-col>
                <el-col :span="22">{{regpatient.presentIllness}}</el-col>
              </el-row> -->
              <!-- <el-row class="content-item">
                <el-col :span="6"><label >检查号：</label>{{regpatient.}}</el-col>
                <el-col :span="6"><label >操作技师：</label></el-col>
              </el-row> -->
            </div>
          </div>
           <!--申请信息结束-->
           <!--检查信息开始-->
           <div class="content-wrapper">
            <div id="procedureinfo" class="patient-title"><svg-icon  icon-class='check-info' style="margin-right:10px;"></svg-icon>检查信息</div>
            <div class="patient-content">
                <el-table :data="regpatient.items" stripe style="width: 100%">
                  <el-table-column prop="performNo" label="检查号" width="180"></el-table-column>
                  <el-table-column prop="deviceTypeName" label="设备类型" width="100"></el-table-column>
                  <el-table-column prop="bodyPart" label="检查部位" width="150"></el-table-column>
                  <el-table-column prop="itemName" label="检查项目" width="150"></el-table-column>
                  <el-table-column prop="scanMode" label="扫描类型" width="150"></el-table-column>
                  <el-table-column prop="deviceName" label="影像室"></el-table-column>
              </el-table>
            </div>
          </div>
           <!--检查信息结束-->
           <!--详细信息开始-->
           <div class="content-wrapper">
            <div id="detailinfo" class="patient-title"><svg-icon  icon-class='news_hot' style="margin-right:10px;"></svg-icon>详细信息</div>
            <div class="patient-content">
              <el-row class="content-item">
                <el-col :span="2"><label >证件号：</label></el-col>
                <el-col :span="4">{{regpatient.patient.certNo}}&nbsp;</el-col>
                <el-col :span="2"><label >籍贯：</label></el-col>
                <el-col :span="4">{{regpatient.patient.nation}}&nbsp;</el-col>
                <el-col :span="2"><label >职业：</label></el-col>
                <el-col :span="4">{{regpatient.applyDepart}}&nbsp;</el-col>
                <el-col :span="2"><label >婚姻状况：</label></el-col>
                <el-col :span="4">{{regpatient.patient.wedlock}}&nbsp;</el-col>
              </el-row>
              <el-row class="content-item">
                <el-col :span="2"><label >临床诊断：</label></el-col>
                <el-col :span="10">{{regpatient.diagnosis}}&nbsp;</el-col>
                <el-col :span="2"><label >既往史：</label></el-col>
                <el-col :span="10">{{regpatient.pastHistory}}&nbsp;</el-col>
              </el-row>
            </div>
          </div>
           <!--详细信息结束-->
        </el-col>
      </el-row>
    </el-row>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
export default {
  name: 'patient',
  data() {
    return {
      Loading: false,
      regId: '',
      scrollTop: 0,
      patientInfo: ''
    }
  },
  computed: {
    ...mapGetters([
      'regpatient'
    ])
  },
  created: function() {
    this.regId = this.$route.query.regId
    this.init()
  },
  methods: {
    init: function() {
      // window.scrollTo(0, 1000)
      this.Loading = true
      this.$store
        .dispatch('getRegisterPatient', this.regId)
        .then(() => {
          this.Loading = false
        })
        .catch(() => {
          this.Loading = false
        })
    }
  },
  filters: {
    birthDate(datas) {
      return formatDate(new Date(datas), 'yyyy-MM-dd')
    }
  }
}
  </script>

  <style  rel="stylesheet/scss" lang="scss" scoped>
  .patient-continer{
    overflow-y: auto;
    height:100%;
    transition: .5s;
    font-weight: normal !important;
    label{
      font-weight: normal !important;
    }
    .patient-wrapper{
      width:80%;
      margin: 0 auto;
      padding: 30px 0;
    }
    .patient-subheader{
      color: #3A4A64;
      height: 60px;
      line-height: 60px;
      border-bottom:2px solid #DDDDDD;
      font-size: 18px;
    }
    .main{
      margin-top:20px;
      .el-menu{
        border:none;
        height: 400px;
        background-color: #f8f8f8;
        position: absolute;
        .el-menu-item{
          height: 50px;
          line-height: 50px;
          width: 135px;
          margin: 15px;
          border-radius: 6px;
        }
      }
      .patient-main{
        margin-left: 155px;
        padding:0 0 0 20px;
        .content-wrapper{
          margin-top: 20px;
          border-top: 2px solid #DDDDDD;
          background: #f8f8f8;
        }
        .patient-title{
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          font-weight: bold;
          border-bottom: 2px solid #DDDDDD;
          color:#3A4A64;
          padding-left: 20px;
        }
        .patient-content{
          // padding: 40px 0;
          font-size: 14px;
          .content-item{
            line-height: 50px;
            padding-left: 20px;
            color:#3A4A64;
            .item-label{
              font-weight: normal;
              display:inline-block;
              width:120px;
              text-align: right;
            }
            .patient-basicinfo{
              border: 1px solid #C8C8C8;
              border-radius: 5px;
              width:80%;
              margin:0 auto;
              padding: 10px 0;
              .basicinfo-item{
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
      }
    }
     .el-menu-item.is-active{
       background-color: #C9DFFF;
     }
  }
  </style>
